<script lang="ts">
import i3pSubComponent from '../../I3pSubComponent.vue'
import EditButtonsBottomContent from './Content.vue'

export default {
    name: 'EditButtonsBottom',
    components: { EditButtonsBottomContent },
    extends: i3pSubComponent,
    computed: {
        editMode() {
            return this.i3pService.editMode
        },
    },
}
</script>

<template>
    <v-navigation-drawer
        v-if="editMode"
        location="bottom"
        sticky
        permanent
        rail
    >
        <div class="pa-4 text-center">
            <EditButtonsBottomContent :i3p-service />
        </div>
    </v-navigation-drawer>
</template>
